import { Suspense, lazy, useEffect } from "react";
import "./Header.less";

// import ProductPC from "../../assets/ProductPC.svg"
import BrochurePC from "../../assets/BrochurePC.svg";
import ProductPC from "../../assets/ICICI-Life-Guaranteed-Pension-Plan-Logo.svg"
// import BrochureMob from "../../assets/BrochureMob.svg"
import CommonStore from "../../Configs/Store/common";
import { downloadFile } from "../Common/CommonFunctions";
import { DataLayerFn } from "../../Configs/API";
import { observer } from "mobx-react";
import FormStore from "../../Configs/Store/forms";
import HeaderNav from "@ipru-common/components/CommonComponents/HandoverHeader/HeaderNav";
import { PAGE_STEPS } from "@ipru-common/constants/products";
import { useGlobalContext } from "@ipru-common/context/GlobalContext";
const ExtraHeader = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import("./ExtraHeader"),
    new Promise((resolve) => setTimeout(resolve, 0)),
  ]);
  return moduleExports;
});

// const BrochureMobIcon = () => <Image src={BrochureMob} alt={""} />

const HeaderModule = observer(() => {
  const { setGlobal } = useGlobalContext();
  useEffect(() => {
    const currentPageStep =
      FormStore.quoteScreen === true
        ? PAGE_STEPS.quoteScreen
        : PAGE_STEPS.calculator;
    setGlobal((prev) => ({ ...prev, currentPageStep }));
  }, [FormStore.quoteScreen]);
  // const getDimension = useStoreState((state) => state.dimension)
  // const headerAction = useStoreActions((actions) => actions.Header)
  // const calculateState = useStoreState((actions) => actions.calculateState)
  // const proccedModalState = useStoreState((state) => state.proccedModal)
  // const apiDataState = useStoreState((actions) => actions.apiData)

  const BrochureURL =
    "https://icicilife.com/content/dam/icicipru/brochures/ICICI_Pru_Guaranteed_Pension_Plan.pdf";
  const fileName = "ICICI_Pru_Guaranteed_Pension_Plan.pdf";

  const handlemodalOpen = () => {
    // CommonStore.setexpertModal(true);
    FormStore.quoteScreen === true
      ? DataLayerFn(
          `TalkToExpert_Selected||Calculator-QuoteScreen|Talk to Expert`,
          FormStore,
          "",
          "Consult an Expert",
          "",
          "",
        )
      : DataLayerFn(
          `TalkToExpert_Selected||Calculator-Landing Page|Talk to Expert`,
          FormStore,
          "",
          "Consult an Expert",
          "",
          "",
        );
  };

  // const handleCallMob = () => {
  // Not Used.
  // window.open(`tel:${TalkToExpertModalJson.mobileContact}`)
  // DataLayerFn(
  //   "TalkToExpert_Selected||Header|Talk to Expert",
  //   calculateState,
  //   proccedModalState,
  //   apiDataState,
  //   "",
  //   "Talk to an Expert ",
  //   "",
  //   ""
  // )
  // }

  const downloadBrochure = () => {
    downloadFile(BrochureURL, fileName);
    var subSection = "Calculator - Landing Page";
    if (FormStore.quoteScreen === true) {
      DataLayerFn(
        `DownloadBrochure||Calculator-QuoteScreen|Brochure`,
        FormStore,
        "",
        "Talk to an Expert",
        "",
        "",
      );
    } else {
      DataLayerFn(
        `DownloadBrochure||${subSection}|Brochure`,
        FormStore,
        "",
        "Brochure",
        "",
        "",
      );
    }
  };

  // const homePage = () => {
  //   window.location = "https://www.icicilife.com/"
  // }

  const knowMore = () => {
    window.location =
      "https://icicilife.com/retirement-pension-plans/guaranteed-pension-plan.html?UID=2399";
  };

  const headerProps = {
    productLogo: ProductPC,
    productLogoAltText: "ICICI Life Guaranteed Pension Plan",
    showSeperator: false,
    productOnClick: knowMore,

    brochureText: "Brochure",
    brochureFile: BrochureURL,
    onClickBrochureDownload: downloadBrochure,
    onNeedHelpClick: handlemodalOpen,
    openModalRef: true,
  };

  return (
    <>
      <div className="BlankClass" style={{ display: "none" }}>
        <Suspense fallback={<div style={{ display: "none" }}></div>}>
          <ExtraHeader />
        </Suspense>
      </div>
      <div className="ipru-common-module">
        <HeaderNav {...headerProps} />
      </div>
    </>
  )
})

export default HeaderModule
